import React, { createContext, useCallback, useContext, useState } from "react";
import { Alert, AlertColor, Snackbar } from "@mui/material";

interface ToastContextValue {
  showToast: (message: string, severity?: AlertColor) => void;
}

const ToastContext = createContext<ToastContextValue>({ showToast: () => {} });

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }: { children: React.ReactNode }) => {
  const [toast, setToast] = useState<{
    message: string;
    severity: AlertColor;
  } | null>(null);

  const showToast = useCallback(
    (message: string, severity: AlertColor = "error") => {
      setToast({ message, severity });
    },
    []
  );

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <Snackbar
        open={toast !== null}
        autoHideDuration={5000}
        onClose={() => setToast(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setToast(null)}
          severity={toast?.severity ?? "error"}
          variant="filled"
          sx={{ width: "100%", borderRadius: 2 }}
        >
          {toast?.message}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
};
